import "./*.scss";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import Swiper, { Pagination } from "swiper";
import { media } from "../../assets/js/utilities/media.js";

function setup({ el }) {
  const context = el;
  const selectors = {
    reviews: "[data-swiper-reviews]",
    item: ".c-reviews__item",
  };
  const elements = {
    reviews: context.querySelector(selectors.reviews),
    items: context.querySelectorAll(selectors.item),
  }
  let swiper;

  Swiper.use([Pagination]);

	const match = () => {
		swiper = new Swiper(elements.reviews, {
			spaceBetween: 25,
			loop: true,
			centeredSlides: true,
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				clickable: true,
			},
			breakpoints: {
				[media.sizes.xs]: {
					slidesPerView: 1,
				},
			},
		});
	};

	const unmatch = () => {
		if (!elements.reviews.swiper) return;

		swiper.destroy(true, true);
	};

  if (!elements.reviews) return;

	media.is("sm", "max", match, unmatch);
}

function init() {

  document.querySelectorAll("[data-module='reviews']").forEach((el) => {
		setup({ el });
	});

}

export default init;
